import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

interface Configuration {
  LogInAPIEndpoint: string;
  APIEndpoint: string;
  PowerBi_GroupId: string;
  Revenue_ReportId: string;
}
@Injectable({providedIn: 'root'})
export class ConfigService {
  private readonly CONFIG_URL = 'assets/config/config.json';
  public configuration$: Observable<Configuration>;
  public endpoints;
  constructor(private http: HttpClient) {
  }
  public loadConfigurations(): any {
    if (!this.configuration$) {
      this.configuration$ = this.http.get<Configuration>(this.CONFIG_URL).pipe(
        shareReplay(1)
      );
    }
    this.setEndPoint();
    return this.configuration$;
  }
  setEndPoint(){
    this.configuration$.subscribe(res => {
      this.endpoints = res;
    });
  }
}
